import * as React from 'react'
import Image from 'components/Image';

import account_strategy from 'images/icons/account_strategy.svg';
import analytics_ai from 'images/icons/analytics_ai.svg';
import brand_strategy from 'images/icons/brand_strategy.svg';
import business_development from 'images/icons/business_development.svg';
import business_strategy from 'images/icons/business_strategy.svg';
import creative from 'images/icons/creative.svg';
import digital_development from 'images/icons/digital_development.svg';
import digital_innovation from 'images/icons/digital_innovation.svg';
import digital_marketing from 'images/icons/digital_marketing.svg';
import energy from 'images/icons/energy.svg';
import financial from 'images/icons/financial.svg';
import food_beverage from 'images/icons/food_beverage.svg';
import healthcare from 'images/icons/healthcare.svg';
import influencer_marketing from 'images/icons/influencer_marketing.svg';
import management from 'images/icons/management.svg';
import media from 'images/icons/media.svg';
import operations from 'images/icons/operations.svg';
import other_industries from 'images/icons/other_industries.svg';
import pr from 'images/icons/pr.svg';
import project_management from 'images/icons/project_management.svg';
import social_media from 'images/icons/social_media.svg';
import travel_hospitality from 'images/icons/travel_hospitality.svg';
import addy from 'images/icons/addy.svg';

import stat_eye_icon from 'images/stat-eye-icon.svg';
import pieChart from 'images/pie-chart-icon.svg';
import barGraph from 'images/bar-graph-icon.svg';
import flat_close from 'images/flat-close.svg';

const icons = {
	account_strategy,
	analytics_ai,
	brand_strategy,
	business_development,
	business_strategy,
	creative,
	digital_development,
	digital_innovation,
	digital_marketing,
	energy,
	financial,
	food_beverage,
	healthcare,
	influencer_marketing,
	management,
	media,
	operations,
	other_industries,
	pr,
	project_management,
	social_media,
	travel_hospitality,
	addy,
	'eye': stat_eye_icon,
	'bar': barGraph,
	'pie': pieChart,
	'foamcup': food_beverage,
	'bullseye': brand_strategy,
	flat_close,
};

export default function Icon({ width, height, background, foreground, symbol, title, className, onClick, style }) {
	let heightAssumed = false;
	if (height === undefined) {
		heightAssumed = true;
		height = '100%';
	}
	if (background === undefined) background = 'black';
	if (foreground === undefined) foreground = 'white';
	if (title === undefined) title = symbol;

	switch (symbol) {
		case 'arrow':
			return (
				<svg onClick={onClick} width={width} height={height} style={style} className={className} viewBox="0 0 32.375 18.4014" xmlns="http://www.w3.org/2000/svg" aria-label={title}>
					<title>{title}</title>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g fill={foreground} fillRule="nonzero">
							<path d="M32.375,2.30179 C32.375,2.89031 32.1492,3.47911 31.6975,3.92761 L17.8225,17.7276 C16.9192,18.626 15.4558,18.626 14.5525,17.7276 L0.67749,3.92761 C-0.22583,3.02917 -0.22583,1.5737 0.67749,0.67526 C1.58081,-0.22317 3.04419,-0.22317 3.94751,0.67526 L16.1875,12.8494 L28.4293,0.67383 C29.3326,-0.22461 30.796,-0.22461 31.6993,0.67383 C32.151,1.12305 32.375,1.71242 32.375,2.30179 Z"></path>
						</g>
					</g>
				</svg>
			)
		
		case 'filter':
			return (
				<svg onClick={onClick} width={width} height={height} style={style} className={className} viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={title}>
					<title>{title}</title>
					<g>
						<path d="M15.0518 2.71067C19.0444 2.71067 23.0517 2.71067 27.0573 2.71067C28.8599 2.71067 30.6625 2.70905 32.4651 2.71067C33.5528 2.71067 34.0683 3.08923 34.044 3.85929C34.0213 4.60669 33.4831 4.96746 32.3986 4.96746C26.8562 4.96746 21.3155 4.97393 15.7732 4.95613C15.2252 4.95451 14.9318 5.09202 14.6708 5.61295C14.003 6.95084 12.8293 7.64971 11.3509 7.66104C9.81258 7.67236 8.57896 6.98967 7.89164 5.57412C7.64848 5.07099 7.3648 4.94804 6.85093 4.95613C4.99483 4.98363 3.13873 4.96584 1.28263 4.97069C0.68609 4.97069 0.14466 4.75553 0.0409135 4.16828C-0.0239283 3.79458 0.170597 3.28821 0.418617 2.97598C0.585585 2.76567 1.0492 2.72685 1.38152 2.72361C3.23762 2.70096 5.09371 2.73008 6.94981 2.69288C7.22539 2.68802 7.62416 2.48904 7.74574 2.26255C8.52547 0.800088 9.691 -0.031445 11.3607 0.000910394C13.0271 0.0332657 14.1943 0.874505 14.8638 2.40006C14.9059 2.49713 14.974 2.58287 15.0518 2.70905V2.71067Z" fill={foreground}/>
						<path d="M10.132 17.6121C7.22705 17.6121 4.32376 17.6331 1.42046 17.5895C0.992507 17.583 0.48512 17.3614 0.172258 17.0702C-0.0190251 16.8906 -0.0627934 16.2677 0.100932 16.0623C0.365163 15.7323 0.849855 15.4039 1.2535 15.3893C3.15985 15.3197 5.07106 15.3553 6.98065 15.3553C10.9879 15.3553 14.9935 15.3505 19.0007 15.3667C19.4773 15.3683 19.7496 15.2728 19.9847 14.7923C20.6704 13.393 21.8618 12.6682 23.4181 12.6698C24.9386 12.6715 26.1203 13.3574 26.8028 14.7341C27.0443 15.2211 27.3231 15.378 27.8467 15.3683C29.3527 15.3359 30.8587 15.3537 32.3646 15.3586C33.5172 15.3618 34.0521 15.7323 34.044 16.5072C34.0359 17.2805 33.5399 17.6073 32.3403 17.6121C30.8343 17.617 29.3284 17.6283 27.8224 17.604C27.3426 17.5959 27.0768 17.714 26.8449 18.1929C26.1803 19.5599 25.0294 20.2879 23.4991 20.3203C21.9332 20.3526 20.7336 19.6521 20.0252 18.2689C19.7594 17.7512 19.4773 17.5976 18.9261 17.6024C15.9953 17.6267 13.0644 17.6137 10.1336 17.6137L10.132 17.6121Z" fill={foreground}/>
						<path d="M8.10081 28.0402C12.1113 28.0402 16.1153 28.0402 20.1209 28.0402C24.261 28.0402 28.4028 28.0385 32.5429 28.0369C33.535 28.0369 34.0635 28.4414 34.044 29.1904C34.0262 29.9135 33.5301 30.2937 32.5721 30.2937C24.6679 30.2953 16.7621 30.3002 8.85783 30.2856C8.32289 30.2856 8.01813 30.3924 7.76201 30.9311C7.0066 32.5149 5.22021 33.2963 3.50352 32.8967C1.76414 32.4906 0.561323 31.0233 0.522418 29.26C0.483513 27.4626 1.66363 25.8998 3.39815 25.4517C5.12295 25.0068 6.85098 25.7462 7.72148 27.3057C7.85116 27.537 7.96626 27.7765 8.10243 28.0402H8.10081Z" fill={foreground}/>
					</g>
				</svg>
			)
		
		case 'sort':
			return (
				<svg onClick={onClick} width={width} height={height} style={style} className={className} viewBox="0 0 34 27.2333272" xmlns="http://www.w3.org/2000/svg" aria-label={title}>
					<title>{title}</title>
						<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
							<g transform="translate(0.000000, 0.000000)" fillRule="nonzero">
								<path d="M7.2861603,0.49870807 C7.60534038,0.179614406 8.03827206,0.000361365582 8.48958625,0.000361365582 C8.94090043,0.000361365582 9.37375356,0.179614406 9.69293363,0.49870807 L16.5012969,7.30707916 C16.8112857,7.62806606 16.9828558,8.05801255 16.9790699,8.50429904 C16.9751571,8.95058553 16.796124,9.37746827 16.4805576,9.69303469 C16.1649912,10.0086011 15.7380299,10.1876342 15.2917434,10.1914835 C14.8454569,10.1954114 14.4155104,10.0238413 14.0945235,9.71377393 L10.1916181,5.81094709 L10.1916181,25.5312953 C10.1916181,25.9826881 10.0123494,26.4156198 9.69309075,26.7347998 C9.37391067,27.0540585 8.94097899,27.2333272 8.48958625,27.2333272 C8.03811494,27.2333272 7.60518326,27.0540585 7.28600319,26.7347998 C6.96682311,26.4156198 6.7874758,25.9826881 6.7874758,25.5312953 L6.7874758,5.81094709 L2.88460183,9.71377393 C2.5635835,10.0238413 2.13363701,10.1954114 1.68735052,10.1914835 C1.24107188,10.1876342 0.814165581,10.0086011 0.498591303,9.69303469 C0.18300917,9.37746827 0.00399965867,8.95058553 6.23313315e-05,8.50429904 C-0.00375398979,8.05801255 0.167808248,7.62806606 0.477852061,7.30707916 L7.2861603,0.49870807 Z M23.8083446,21.4224116 L23.8083446,1.70206331 C23.8083446,1.25067057 23.9876133,0.817731032 24.306872,0.498527387 C24.6260521,0.179323742 25.0589837,0 25.5103765,0 C25.9618478,0 26.3947795,0.179323742 26.7139595,0.498527387 C27.0331396,0.817731032 27.2124869,1.25067057 27.2124869,1.70206331 L27.2124869,21.4224116 L31.1153923,17.5195847 C31.4363792,17.2095173 31.8663257,17.0379473 32.3126122,17.0417966 C32.7588987,17.0457245 33.1857814,17.224679 33.5013479,17.540324 C33.8169928,17.8558904 33.9959474,18.2827731 33.9999387,18.7290596 C34.0037246,19.1753461 33.8321545,19.6052926 33.5220871,19.9262795 L26.7138024,26.7346427 C26.3946224,27.0537442 25.9617692,27.233013 25.5103765,27.233013 C25.0590623,27.233013 24.6262092,27.0537442 24.3070291,26.7346427 L17.4986659,19.9262795 C17.188677,19.6052926 17.017107,19.1753461 17.0208929,18.7290596 C17.0248056,18.2827731 17.2038387,17.8558904 17.5194051,17.540324 C17.8350501,17.224679 18.2619328,17.0457245 18.7082193,17.0417966 C19.1545058,17.0379473 19.5844523,17.2095173 19.9054392,17.5195847 L23.8083446,21.4224116 Z" fill={foreground}></path>
							</g>
						</g>
				</svg>
			)
		
		case 'search':
			return (
				<svg onClick={onClick} width={width} height={height} style={style} className={className} viewBox="0 0 34.9998608 35.0037285" xmlns="http://www.w3.org/2000/svg" aria-label={title}>
					<title>{title}</title>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g fill={foreground} fillRule="nonzero">
							<path d="M34.2001108,30.3310785 L26.0175108,22.1483785 C27.8782108,19.3859785 28.7963108,15.9345785 28.3048108,12.2567785 C27.4667108,6.00124854 22.3398108,0.910523542 16.0780108,0.117760542 C6.7681808,-1.06028146 -1.0603292,6.76823854 0.117771802,16.0780785 C0.910740802,22.3425785 6.0021508,27.4735785 12.2584108,28.3075785 C15.9361108,28.7990785 19.3883108,27.8812785 22.1500108,26.0202785 L30.3326108,34.2028785 C31.4004108,35.2706785 33.1319108,35.2706785 34.1997108,34.2028785 C35.2665108,33.1337785 35.2665108,31.3974785 34.2001108,30.3310785 Z M5.4071508,14.2186785 C5.4071508,9.39391854 9.3323408,5.46872854 14.1571108,5.46872854 C18.9819108,5.46872854 22.9071108,9.39391854 22.9071108,14.2186785 C22.9071108,19.0435785 18.9819108,22.9686785 14.1571108,22.9686785 C9.3323408,22.9686785 5.4071508,19.0448785 5.4071508,14.2186785 Z"></path>
						</g>
					</g>
				</svg>
			)

		case 'gallery-chevron-left':
			return (
				<svg onClick={onClick} width={width} height={height} style={style} className={className} viewBox="0 0 23 37" xmlns="http://www.w3.org/2000/svg" aria-label={title}>
					<title>{title}</title>
					<g clipPath="url(#clip0_5766_7144)">
						<path d="M16.1001 2.3125C15.5116 2.3125 14.9228 2.53833 14.4743 2.98999L0.674318 16.865C-0.22412 17.7683 -0.22412 19.2317 0.674318 20.135L14.4743 34.01C15.3728 34.9133 16.8282 34.9133 17.7267 34.01C18.6251 33.1067 18.6251 31.6433 17.7267 30.74L5.55247 18.5L17.7281 6.25821C18.6265 5.35488 18.6265 3.89151 17.7281 2.98819C17.2789 2.53653 16.6895 2.3125 16.1001 2.3125Z" fill="white" />
					</g>
					<defs>
						<clipPath id="clip0_5766_7144">
							<rect width="23" height="37" transform="matrix(1 8.74228e-08 8.63072e-08 -1 0 37)" />
						</clipPath>
					</defs>
				</svg>
			)

		case 'gallery-chevron-right':
			return (
				<svg onClick={onClick} width={width} height={height} style={style} className={className} viewBox="0 0 23 37" xmlns="http://www.w3.org/2000/svg" aria-label={title}>
					<title>{title}</title>
					<g clipPath="url(#clip0_5766_7142)">
						<path d="M6.89987 2.3125C7.48838 2.3125 8.07718 2.53833 8.52568 2.98999L22.3257 16.865C23.2241 17.7683 23.2241 19.2317 22.3257 20.135L8.52569 34.01C7.62725 34.9133 6.17178 34.9133 5.27334 34.01C4.3749 33.1067 4.3749 31.6433 5.27334 30.74L17.4475 18.5L5.2719 6.25821C4.37347 5.35488 4.37347 3.89151 5.2719 2.98819C5.72112 2.53653 6.3105 2.3125 6.89987 2.3125Z" fill="white" />
					</g>
					<defs>
						<clipPath id="clip0_5766_7142">
							<rect width="23" height="37" fill="white" transform="translate(23 37) rotate(180)" />
						</clipPath>
					</defs>
				</svg>
			)

		case 'chevron-right':
			return (
				<svg onClick={onClick} width={width} height={height} style={style} className={className} viewBox="0 0 11 20" xmlns="http://www.w3.org/2000/svg" aria-label={title}>
				    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="bevel">
				        <g transform="translate(-580, -1308)" stroke={foreground}>
				            <g transform="translate(581, 1309)">
				                <polyline transform="translate(4.5, 9) rotate(-90) translate(-4.5, -9)" points="-4.5 4.5 4.5 13.5 13.5 4.5"></polyline>
				            </g>
				        </g>
				    </g>
				</svg>
			)

		case 'chevron-left':
			return (
				<svg onClick={onClick} width={width} height={height} style={style} className={className} viewBox="0 0 11 20" xmlns="http://www.w3.org/2000/svg" aria-label={title}>
				    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="bevel">
				        <g transform="translate(-494, -1308)" stroke={foreground}>
				            <g transform="translate(495, 1309)">
				                <polyline transform="translate(4.5, 9) scale(-1, 1) rotate(-90) translate(-4.5, -9)" points="-4.5 4.5 4.5 13.5 13.5 4.5"></polyline>
				            </g>
				        </g>
				    </g>
				</svg>
			)
		
		default:
			if (icons[symbol] === undefined)return (
				<div>{symbol} is not found.</div>
			)
			const args = {
				src: icons[symbol],
				className: className,
			};
			if (style)args.sx = style;
			if (!heightAssumed && height)args.height = height;
			if (width)args.width = width;
			args.alt = title;
			return <Image {...args} />
	}
}